<h1 mat-dialog-title>{{data.title | translate}}</h1>
<mat-dialog-content class="content">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
  <!-- This is the tree node template for leaf nodes -->
  <!-- There is inline padding applied to this node using styles.
    This padding value depends on the mat-icon-button width. -->
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle [class.selected]='isSelected(node)' [attr.data-selected]='isSelected(node) || null'>
    <button mat-icon-button matTreeNodeToggle disabled>
    <mat-icon class="mat-icon-rtl-mirror">arrow_right</mat-icon>
    </button>
    <!--
    <mat-checkbox class="checklist-leaf-node"
                  [checked]="isSelected(node)"
                  (select)='selectNode(node)'>{{node.text}}</mat-checkbox>
                  -->
    <span (click)=selectNode(node) >{{node.text}}</span>
  </mat-tree-node>
  <!-- This is the tree node template for expandable nodes -->
  <mat-nested-tree-node  *matTreeNodeDef="let node; when: hasChild">
    <div class="mat-tree-node" [attr.data-selected]='isSelected(node) || null' [class.selected]='isSelected(node)'>
      <button mat-icon-button matTreeNodeToggle
              [attr.aria-label]="'Toggle ' + node.text">
        <mat-icon class="mat-icon-rtl-mirror">
          {{treeControl.isExpanded(node) ? 'indeterminate_check_box' : 'add_box'}}
        </mat-icon>
      </button>
      <span (click)=selectNode(node)>{{node.text}}</span>
    </div>
    <!-- There is inline padding applied to this div using styles.
        This padding value depends on the mat-icon-button width.  -->
    <div [class.example-tree-invisible]="!treeControl.isExpanded(node)"
         role="group">
      <ng-container matTreeNodeOutlet></ng-container>
    </div>
  </mat-nested-tree-node>
  </mat-tree>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="submit()">{{'DIALOGS.OK' | translate}}</button>
  <button mat-button (click)="cancel()" cdkFocusInitial>{{'DIALOGS.CANCEL' | translate}}</button>
</mat-dialog-actions>
